module.exports = __webpack_public_path__ + "img/Maddarsi.17de4a49.jpg";